(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    try { sessionStorage.removeItem('promo-bar-closed'); } catch (e) {}

    var promoBar = document.querySelector('[data-promo-bar]');
    if (promoBar) {
      function triggerPromo() {
        document.querySelectorAll('[data-newsletter-tags]').forEach(function (input) {
          input.value = 'newsletter, source-promo';
        });
        try { sessionStorage.setItem('newsletter_source', 'promo'); } catch (err) {}
        if (window.location.hash === '#newsletter') {
          var target = document.getElementById('newsletter');
          if (target) target.scrollIntoView({ behavior: 'smooth' });
        } else {
          window.location.hash = 'newsletter';
        }
      }
      promoBar.addEventListener('click', function (e) {
        var inner = e.target.closest('a');
        if (inner && inner.getAttribute('href') && inner.getAttribute('href').charAt(0) !== '#') {
          return;
        }
        e.preventDefault();
        triggerPromo();
      });
      promoBar.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          triggerPromo();
        }
      });
    }

    var ticking = false;
    function update() {
      var threshold = window.innerHeight * 0.3;
      if (window.scrollY > threshold) {
        document.body.classList.add('is-scrolled');
      } else {
        document.body.classList.remove('is-scrolled');
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var intervalId = null;

    function init() {
      var hero = document.querySelector('.hero');
      if (!hero) return;
      var slides = hero.querySelectorAll('.hero__image');
      if (slides.length < 2) return;

      if (intervalId) clearInterval(intervalId);

      var current = 0;
      slides.forEach(function (slide, i) {
        if (i === 0) slide.classList.add('hero__image--active');
        else slide.classList.remove('hero__image--active');
      });

      intervalId = setInterval(function () {
        slides[current].classList.remove('hero__image--active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('hero__image--active');
      }, 4000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'newsletter_source';
    var IMAGE_KEY = 'newsletter_image';
    var ALT_KEY = 'newsletter_image_alt';
    var NAME_KEY = 'newsletter_product_name';
    var POPUP_OPENED_KEY = 'newsletter_popup_opened';
    var SCROLL_KEY = 'newsletter_popup_scroll_y';
    var BASE_TAGS = 'newsletter';
    var popup = document.getElementById('newsletter-popup');
    if (!popup) return;
    var media = popup.querySelector('[data-newsletter-popup-media]');
    var image = popup.querySelector('[data-newsletter-popup-image]');
    var bodyEl = popup.querySelector('[data-newsletter-popup-body]');
    var bodyWrap = popup.querySelector('[data-newsletter-popup-product-template]');
    var titleEl = popup.querySelector('[data-newsletter-popup-title]');
    var formWrap = popup.querySelector('[data-newsletter-popup-form]');
    var productTemplate = bodyWrap ? bodyWrap.getAttribute('data-newsletter-popup-product-template') : '';
    var defaultBodyHTML = bodyEl ? bodyEl.innerHTML : '';
    var lastFocused = null;

    function resetToFormState() {
      if (titleEl && titleEl.dataset.defaultTitle) {
        titleEl.textContent = titleEl.dataset.defaultTitle;
        titleEl.removeAttribute('data-newsletter-popup-feedback');
        titleEl.removeAttribute('data-newsletter-popup-success');
      }
      if (bodyEl) bodyEl.hidden = false;
      if (formWrap) formWrap.hidden = false;
      var emailInput = popup.querySelector('input[type="email"]');
      if (emailInput) emailInput.value = '';
      var errorEl = popup.querySelector('.newsletter-popup__feedback--error');
      if (errorEl && errorEl.parentNode) errorEl.parentNode.removeChild(errorEl);
    }

    function escapeHtml(s) {
      return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function setBody(productName) {
      if (!bodyEl) return;
      if (productName && productTemplate) {
        bodyEl.innerHTML = productTemplate.replace('__NAME__', escapeHtml(productName));
      } else {
        bodyEl.innerHTML = defaultBodyHTML;
      }
    }

    function getTagsInputs() {
      return document.querySelectorAll('[data-newsletter-tags]');
    }

    function applySource(source) {
      getTagsInputs().forEach(function (input) {
        input.value = source ? BASE_TAGS + ', source-' + source : BASE_TAGS;
      });
    }

    function setMedia(src, alt) {
      if (!media || !image) return;
      if (src) {
        image.src = src;
        image.alt = alt || '';
        media.hidden = false;
      } else {
        image.removeAttribute('src');
        image.alt = '';
        media.hidden = true;
      }
    }

    try {
      var storedSource = sessionStorage.getItem(STORAGE_KEY);
      if (storedSource) applySource(storedSource);
    } catch (e) {}

    function openPopup() {
      lastFocused = document.activeElement;
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('newsletter-popup-open');
      var emailInput = popup.querySelector('input[type="email"]');
      if (emailInput && !popup.querySelector('[data-newsletter-popup-feedback]')) {
        emailInput.focus();
      }
    }

    function closePopup() {
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('newsletter-popup-open');
      try { sessionStorage.removeItem(POPUP_OPENED_KEY); } catch (e) {}
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-newsletter-popup]');
      if (trigger) {
        event.preventDefault();
        resetToFormState();
        var source = trigger.dataset.newsletterSource;
        var img = trigger.dataset.newsletterPopupImage;
        var alt = trigger.dataset.newsletterPopupAlt;
        if (source) {
          applySource(source);
          try { sessionStorage.setItem(STORAGE_KEY, source); } catch (e) {}
        }
        setMedia(img, alt);
        setBody(alt);
        try {
          if (img) sessionStorage.setItem(IMAGE_KEY, img); else sessionStorage.removeItem(IMAGE_KEY);
          if (alt) {
            sessionStorage.setItem(ALT_KEY, alt);
            sessionStorage.setItem(NAME_KEY, alt);
          } else {
            sessionStorage.removeItem(ALT_KEY);
            sessionStorage.removeItem(NAME_KEY);
          }
          sessionStorage.setItem(POPUP_OPENED_KEY, '1');
          sessionStorage.setItem(SCROLL_KEY, String(window.scrollY || window.pageYOffset || 0));
        } catch (e) {}
        openPopup();
        return;
      }
      var scrollLink = event.target.closest('a[href^="#newsletter"]');
      if (scrollLink) {
        var s = scrollLink.dataset.newsletterSource;
        if (s) {
          applySource(s);
          try { sessionStorage.setItem(STORAGE_KEY, s); } catch (e) {}
        }
      }
    });

    popup.addEventListener('click', function (event) {
      if (event.target.closest('[data-newsletter-popup-close]')) {
        closePopup();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !popup.hidden) closePopup();
    });

    var popupFeedback = popup.querySelector('[data-newsletter-popup-feedback]');
    var popupWasOpened = false;
    try { popupWasOpened = sessionStorage.getItem(POPUP_OPENED_KEY) === '1'; } catch (e) {}
    if (popupFeedback && popupWasOpened) {
      try {
        var storedScroll = sessionStorage.getItem(SCROLL_KEY);
        if (storedScroll !== null) {
          if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
          window.scrollTo(0, parseInt(storedScroll, 10) || 0);
        }
        var storedImg = sessionStorage.getItem(IMAGE_KEY);
        var storedAlt = sessionStorage.getItem(ALT_KEY);
        var storedName = sessionStorage.getItem(NAME_KEY);
        if (storedImg) setMedia(storedImg, storedAlt);
        if (storedName) setBody(storedName);
      } catch (e) {}
      openPopup();
    }

    if (popupFeedback || document.querySelector('.newsletter__feedback, .newsletter__success')) {
      try {
        sessionStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem(IMAGE_KEY);
        sessionStorage.removeItem(ALT_KEY);
        sessionStorage.removeItem(NAME_KEY);
        sessionStorage.removeItem(POPUP_OPENED_KEY);
        sessionStorage.removeItem(SCROLL_KEY);
      } catch (e) {}
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
